import { FeatureSectionRows } from "../widgets/FeatureRows";
import { WidgetRenderer } from "../widgets/registry";

import { BasePage } from "./BasePage";
import { CAPABILITY_SECTIONS, type CapabilitySection } from "./capabilities-canonical";

import type { PageTemplateProps } from "./types";

// Our Capabilities (Content Optimization room, 2026-09-23, Eric): one page,
// fully canonical. The rows are the website's What-we-do rows, verbatim from
// capabilities-canonical.ts (owned by the site), scoped to the services on
// offer in this room; the stats are the site's content-optimization figures.
// The rate card moved to Your assortment's header (2026-10-05, Eric).

// Site rows in the order a reader should meet them: the score they see in the
// matrix, the copy work, the image work, A+ content, then the catalog data
// behind every listing.
const ROW_IDS = [
    "listing-healthscore",
    "keyword-optimization",
    "customer-review-analysis",
    "infographic-creation",
    "ai-image-enrichment",
    "a-content-creation",
    "multiple-marketplace-listing-management",
] as const;

// bisoncommerce.com/what-we-do/content-optimization, "Key statistics", verbatim.
const SITE_STATS = [
    { value: "640K+", label: "SKUs under content management" },
    { value: "16M+", label: "Product data points maintained" },
    { value: "5M+", label: "Product images maintained" },
    { value: "22K+", label: "Attributes mapped across marketplaces" },
    { value: "14+", label: "Marketplace channels optimized" },
    { value: "350+", label: "Supplier catalogs maintained" },
];

function scopedSection(): CapabilitySection {
    const byId = new Map(CAPABILITY_SECTIONS.flatMap((s) => s.rows.map((r) => [r.id, r] as const)));
    const rows = ROW_IDS.map((id) => byId.get(id)).filter((r): r is NonNullable<typeof r> => Boolean(r));
    return { id: "co-capabilities", title: "", rows: rows.map((r) => ({ ...r, mediaSide: undefined })) };
}

export function COCapabilities(props: PageTemplateProps) {
    const { room } = props;
    // The proposal report's column (`.wrap` in co/proposal.css: 1040px, 32px
    // gutter), so the two pages read at one width (Eric, 2026-09-24).
    return (
        <BasePage {...props} maxWidth={1040}>
            <WidgetRenderer widget={{ type: "stat_band", id: "content-stats", props: { items: SITE_STATS } }} room={room} />

            <FeatureSectionRows section={scopedSection()} />
        </BasePage>
    );
}
